export const HEADER_BAR_HEIGHT = 32;
export const HEADER_NAVIGATION_HEIGHT = 80;
export const HEADER_CONTACTS_HEIGHT = 32;
export const HEADER_PAY_BAR_HEIGHT = 56;
export const HEADER_ANIMATION_Y = 60;
